/*
 * @Author: liangen liangen@oppo.com
 * @Date: 2022-06-27 09:32:54
 * @LastEditors: liangen liangen@oppo.com
 * @LastEditTime: 2022-06-27 11:49:39
 * @FilePath: /cem-portal-frontend/src/pages/Survey/SurveyManagement/components/SurveyContent/components/MatrixCheckboxTopic/MatrixCheckboxContent.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { defineComponent, reactive, watch } from "@vue/composition-api";
// import './index.scss'
import _ from 'lodash'
const MatrixCheckboxContent = defineComponent({
  props: {
    item: {
      type: Object,
      default: () => { }
    }
  },
  setup(props, context) {
    const { emit } = context;
    const state = reactive({
      editItem: _.cloneDeep(props.item) //编辑数据源
    })
    watch(() => props.item, (val) => {
      state.editItem = _.cloneDeep(val);
    }, {
      deep: true
    })

    const elRadioGroupChange = (value, index) => {
      state.editItem.matrixValue[index].value = value;
      state.editItem.isShowTitleError = false;
      emit('answer', state.editItem);
    }

    const getTrueIndex = (item)=>{
      let res:boolean = false
      let resIndex:number = 0
      state.editItem.matrixValue.forEach((ele,index) => {
        if(ele.subTopicId === item.bizId){
          res = true
          resIndex = index
        }
      })
      if(res){
        return resIndex
      }else{
        return state.editItem?.matrixValue?.length
      }
    }

    return () => {
      return (<div class='matrix-content'>
        <div class='matrix-header'>
          <div class='matrix-header-item'></div>
          {
            props.item.topicSetting.topicOptionSetting?.map(item => {
              return <div class='matrix-header-item' domPropsInnerHTML={item.optionName}></div>
            })
          }
        </div>
        {
          (props.item.matrixTopics || []).map((item, index) => {
            return <div class='matrix-tr-item' key={item.bizId}>
              <div class='sub-topic-title' domPropsInnerHTML={item.topicName} key={item.bizId}>
              </div>
              <el-checkbox-group onInput={value => elRadioGroupChange(value, getTrueIndex(item))} value={state.editItem.matrixValue[getTrueIndex(item)]?.value??[]} style={{ 'flex': props.item.topicSetting.topicOptionSetting?.length }}>
                {
                  props.item.topicSetting.topicOptionSetting?.map((sitem, sindex) => {
                    return <div key={`${item.bizId}${sitem.optionId}`}>
                      <el-checkbox label={sitem.optionId}></el-checkbox>
                    </div>
                  })
                }
              </el-checkbox-group>

            </div>
          })
        }
      </div>)
    }
  }
})
export default MatrixCheckboxContent;
